import {Injectable} from '@angular/core';
import {AppConfigService} from './app-config.service';
import {HttpClient} from '@angular/common/http';
import {UserInfo} from '../model/types';
import {Roles} from '../model/enums';
import * as _ from 'lodash';
import {action, observable} from 'mobx-angular';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  @observable userInfo: UserInfo;

  constructor(private appConfig: AppConfigService, private http: HttpClient, private router: Router) { }

  public logout() {
    if (navigator.onLine === false) {
      this.router.navigate(['/shared/offline']);
    } else {
      window.location.href = this.appConfig.config.gatewayUrl + '/api/logout';
    }
  }

  public login() {
    if (navigator.onLine === false) {
      this.router.navigate(['/shared/offline']);
    } else {
      window.location.href = this.appConfig.config.gatewayUrl + '/oauth2/authorization/calive';
    }
  }

  public getUserInfo(): Promise<UserInfo> {
    if (this.userInfo) {
      return Promise.resolve(this.userInfo);
    }
    return this.http.get<UserInfo>(this.appConfig.config.gatewayUrl + '/api/session', {observe: 'body'})
    .toPromise()
      .then(userInfo => {
        this.updateUserInfo(userInfo);
        return this.userInfo;
    });
  }

  @action private updateUserInfo(userInfo) {
    this.userInfo = userInfo;
  }

  public hasAnyRole(roles: Roles[]): Promise<boolean> {
    return this.getUserInfo().then(userInfo => {
      return roles.filter(role => _.includes(userInfo.roles, role)).length > 0;
    });
  }

  public hasNotAnyRole(roles: Roles[]): Promise<boolean> {
    return this.hasAnyRole(roles).then(hasAnyRole => !hasAnyRole);
  }
}
